import type { Transaction } from "@e308/core";
import type { SeatModel } from "./content-types.js";
import type { Micro } from "./exact-numbers.js";

export function rejectIfEliminated(transaction: Transaction<Micro>, model: SeatModel): void {
  if (transaction.get(model.resources.headquarters) <= 0n)
    transaction.reject({
      code: "disabled",
      actionId: `seat:${model.seat.id}`,
      reasonKey: "seat-eliminated",
    });
}
